import { FormControlLabel } from '@material-ui/core';
import styled, { css } from 'styled-components';

import colors from '~/styles/colors';

import alert from '../../../assets/alert.svg';

export const Container = styled.div`
  display: flex;
  gap: 1.429rem;
`;

export const FormControlOption = styled(FormControlLabel)`
  display: flex;
  height: 3.286rem;
  width: 14.286rem;
  border-radius: 5px;
  margin-left: 0px !important;
  margin-right: 0px !important;
  justify-content: center;
  font-size: 85.71%;
  transition: color 0.5s;
  transition: background-color 0.5s;
  transition: ease-in 0.2s;

  ${(props) =>
    props.checked &&
    css`
      backpground-color: rgba(255, 153, 184, 0.25);
      border: 2px solid ${colors.primary};
      font-weight: bold !important;
      color: ${colors.primary};

      .MuiTypography-body1 {
        font-weight: bold !important;
      }
    `}

  ${(props) =>
    !props.checked &&
    css`
      background-color: transparent;
      border: 1px solid #b3b3b3;

      color: #4d4d4d;
    `}

  & span:first-child {
    display: none;
  }
`;

export const ErrorMessage = styled.span`
  &:last-child {
    color: #c11e1e;
    margin: 5px 0;
  }
  &:last-child:before {
    content: url(${alert});
    padding: 0 10px 0 0;
    vertical-align: -10%;
  }
`;
